import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getUserById, getUserByRef } from "../../models/UserFunctions.js";
import { getOrgById } from "../../models/OrgFunctions.js";

import Space from "../../layout/Space";
import Icon1 from "../../icons/Icon.js";

import PrimaryButton from "../../buttons/PrimaryButton";
import { useSnackbar } from "notistack";
import MemberModal from "../../modals/MemberModal.js";
import Modal1 from "../../modals/Modal1.js";
import MemberColorModal from "../../modals/MemberColorModal.js";
import { useAppContext } from "../../config/AppContext.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";

import SecondaryButton from "../../buttons/SecondaryButton";

import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import Tippy from "@tippyjs/react";

import { SaveBar, ToggleSettingsBrick } from "../../textfields/EasySwitch.js";
import TextField2T from "../../textfields/TextField2T";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03";
import TabGPT from "../../tabs/TabGPT.js";
import SmallSpinner from "../../loading/SmallSpinner.js";

import { memberRoles } from "../../members/MemberManager.js";
import { flutterColorToHex } from "../../models/ColorFunctions.js";
import { User } from "../../types/user.js";
import { Org, OrgInfos, OrgNotifications, Workspace } from "../../types/org.js";

export function getRoleString(role: string) {
  switch (role) {
    case "admin":
      return "Administrateur";
    case "operator":
      return "Opérateur";
    case "conductor":
      return "Conducteur de travaux";
    case "respo":
      return "Responsable";
    case "commercial":
      return "Commercial";
    case "owner":
      return "Gérant (pas opérationnel)";
    case "secretary":
      return "Assistant(e) technique";
    case "drawer":
      return "Dessinateur-Métreur";
    case "comptable":
      return "Comptable";
    case "project_manager":
      return "Chargé de projet";
    case "architect":
      return "Architecte";
    default:
      return "Inconnu";
  }
}

interface OrganisationProps {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  workspaceData: Workspace | null;
  masterData: Org | null;
}

const Organisation: React.FC<OrganisationProps> = ({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
  masterData,
}) => {
  const { currentUser, loading } = useAuth();

  // get the tab parameter from the URL
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const { enqueueSnackbar } = useSnackbar();
  const [infos, setInfos] = useState<OrgInfos | any>({});

  const [users, setUsers] = useState<User[]>([]);
  const [signatures, setSignatures] = useState([]);
  const [tampons, setTampons] = useState([]);

  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [tabs, setTabs] = useState([
    {
      id: "infos",
      label: "Informations",
    },
    {
      id: "members",
      label: "Membres",
    },

    orgData.facturation?.plan !== "free"
      ? {
          id: "notifications",
          label: "Notifications",
        }
      : null,
  ]);
  const [activeTab, setActiveTab] = useState(tab ? tab : "infos");
  const [name, setName] = useState("");
  const [userType, setUserType] = useState<string | number | null>(null);
  const [marqueOpen, setMarqueOpen] = useState(false);
  const [loadingMarque, setLoadingMarque] = useState(false);

  const [restrictions, setRestrictions] = useState(null);
  const [notifications, setNotifications] = useState<OrgNotifications | null>(
    null
  );
  const [marques, setMarques] = useState([]);
  const [marque, setMarque] = useState("");
  const [addMarque, setAddMarque] = useState(false);
  const [bigPhoto, setBigPhoto] = useState<string | null>(null);
  const [signatureName, setSignatureName] = useState("");
  const [newSignatureOpen, setNewSignatureOpen] = useState(false);
  const [newTamponOpen, setNewTamponOpen] = useState(false);

  const [new_email, setNewEmail] = useState("");

  const handleSaveNotifications = async () => {
    try {
      await updateDocDataFieldApi(
        orgData.ref!,
        "notifications",
        notifications,
        prefix
      );
      handleClickVariant("Notifications enregistrées", "success");
    } catch (error) {
      handleClickVariant(
        "Erreur lors de l'enregistrement des notifications",
        "error"
      );
      console.error(error);
    }
  };

  // Fonction pour afficher les messages Snackbar
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (orgData) {
      try {
        let infoss = orgData.infos || {};
        infoss.entreprise = orgData.name;
        setInfos(infoss);

        const users = (await queryCollection("user", [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ])) as any as User[];
        setUsers(users); // Initialise les employés de l'organisation
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };
  const [dropped_files, setDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [droppedExists, setDroppedExists] = useState(false);

  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [orgData]);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;
  // Function to update the organization
  const callModifyMaster = async () => {
    if (!orgData) return; // Ensure orgData is available

    try {
      // Get the user's Firebase authentication token

      // Prepare the data to be sent for updating the organization
      // Call the API to modify the organization

      await updateDocDataFieldApi(orgData.ref, "infos", infos, prefix);
      await updateDocDataFieldApi(
        orgData.ref,
        "name",
        infos.entreprise,
        prefix
      );
      handleClickVariant("Organisation modifiée avec succès", "success");
      navigateWorkspace("/organisation"); // Navigate to the organizations page
    } catch (error) {
      handleClickVariant(
        "Erreur lors de la modification de l'organisation",
        "error"
      );
      console.error(error);
    }
  };

  const handleSaveRestrictions = async () => {
    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "restrictions",
        restrictions,
        prefix
      );
      handleClickVariant("Restrictions enregistrées", "success");
    } catch (error) {
      handleClickVariant(
        "Erreur lors de l'enregistrement des restrictions",
        "error"
      );
      console.error(error);
    }
  };

  const callSendInvite = async (already: any) => {
    if (orgData.type !== "expert") {
      if (!already && (!email || !name || !userType)) {
        handleClickVariant("Veuillez remplir tous les champs", "error");
        return;
      }
    } else {
      if (!already && (!email || !name)) {
        handleClickVariant("Veuillez remplir tous les champs", "error");
        return;
      }
    }

    let email_to_use = already ? email2 : email;

    const filters = [
      {
        field: "email",
        operator: "==",
        value: email_to_use.trim(),
      },
    ];
    const doublons = await queryCollection("user", filters);
    if ((doublons?.length ?? 0) > 0) {
      if (already) {
        handleClickVariant(
          "Cet utilisateur est déjà enregistré dans l'organisation",
          "error"
        );

        return;
      } else {
        handleClickVariant("Cet email est déjà utilisé", "error");
        return;
      }
    } else {
      if (already) {
        handleClickVariant("Cet email n'est pas enregistré", "error");
        return;
      }
    }

    try {
      // await createNewMember(
      //   orgData.id,
      //   email_to_use.trim(),
      //   name.trim(),
      //   userType,
      //   false,
      //   token,
      //   prefix
      // ); // Call the sendInvite API
      let org = (await getOrgById(orgData.id)) as Org;
      let users = (await getArrayDocDataByID("user", org.users_id)) as User[];
      let new_user = users.find((user) => user.email === email_to_use);
      // await sendInvite(
      //   new_user.id,
      //   org.name,
      //   new_user.email,
      //   org.id,
      //   token,
      //   prefix
      // ); // Call the sendInvite API
      handleClickVariant("Invitation envoyée avec succès", "success");
      setEmail("");
      setName("");
      setUserType(null);
      setAddMember(false);
    } catch (error) {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
      console.error(error);
    }
  };
  const handleChangeLogo = async () => {
    const token = await getOrRefreshFirebaseToken();
    // await uploadImage(orgData.id, token, prefix);
    handleClickVariant("Logo modifié avec succès", "success");
    // I want the whole app to refresh
  };

  const handleMemberClick = async (user_id: string, isinfos: any) => {
    const user = (await getDocDataById("user", user_id)) as User;
    setMemberData(user);
    if (isinfos) {
      setMemberOpen(true);
    } else {
      setMemberColorOpen(true);
    }
  };

  const [memberData, setMemberData] = useState<User | null>(null);
  const [addMember, setAddMember] = useState<boolean>(false);
  const [memberOpen, setMemberOpen] = useState<boolean>(false);
  const [memberColorOpen, setMemberColorOpen] = useState<boolean>(false);

  if (loading || !currentUser) {
    return <div></div>; // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full overflow-auto flex flex-col  ">
      <div className="w-full h-fit flex flex-col items-start justify-start ">
        <Modal1 isOpen={memberOpen} onClose={() => setMemberOpen(false)}>
          <MemberModal
            onClose={() => setMemberOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
            orgData={orgData}
          />
        </Modal1>
        <Modal1
          isOpen={memberColorOpen}
          onClose={() => setMemberColorOpen(false)}
        >
          <MemberColorModal
            onClose={() => setMemberColorOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
          />
        </Modal1>
        <Modal1 isOpen={addMember} onClose={() => setAddMember(false)}>
          <div className="flex flex-col w-fit gap-2 h-fit items-center justify-center bg-white p-4 rounded-xl">
            <div className="text-h2 font-medium text-left mb-2">
              Ajouter un nouveau membre
            </div>
            <div className="flex flex-col gap-2 w-fit">
              <TextField2T
                className="w-full text-left"
                label="Email"
                value={email}
                type="email"
                mandatory={true}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField2T
                className="w-full text-left"
                label="Prénom nom"
                value={name}
                mandatory={true}
                onChange={(e) => setName(e.target.value)}
              />

              {orgData.type !== "expert" && (
                <div className="flex flexol gap-2">
                  <DropDownGPT03
                    label="Type d'utilisateur"
                    value={userType ?? undefined}
                    mandatory={true}
                    className={"w-full"}
                    onChange={(e) => setUserType(e.value)}
                    items={memberRoles}
                  />
                </div>
              )}

              <Space y={10} />
              <div className="w-c500 flex flex-row justify-end gap-2">
                <SecondaryButton onClick={() => setAddMember(false)}>
                  Annuler
                </SecondaryButton>

                <PrimaryButton
                  onClick={() => callSendInvite(false)}
                  disabled={!email || !name}
                >
                  <div className="flex flex-row content-center">
                    <Space x={5} />
                    Inviter
                  </div>
                </PrimaryButton>
              </div>
            </div>
          </div>
        </Modal1>
        <Modal1 isOpen={marqueOpen} onClose={() => setMarqueOpen(false)}>
          <div className="flex flex-col p-4 rounded-xl bg-white  shadow-md w-fit ">
            {loadingMarque && (
              <div className="flex flex-row text-h3 text-shadow_50 gap-2 items-center  justify-center w-full h-full">
                <SmallSpinner loading={true}></SmallSpinner> Modification des
                dossiers en cours
              </div>
            )}
            {!loadingMarque && (
              <div className="flex flex-col gap-2 max-w-c500  w-c400 ">
                <TextField2T
                  label="Nom de marque"
                  className="w-c400"
                  value={marque}
                  onChange={(e) => setMarque(e.target.value)}
                  transparent={false}
                ></TextField2T>
                {marqueOpen !== true && (
                  <div className="text-h3 font-light text-gray-400">
                    En modifiant le nom de la marque, vous modifiez le nom de la
                    marque pour tous les dossiers affiliés à cette marque.
                  </div>
                )}
                <div className="flex flex-row justify-between">
                  <SecondaryButton
                    onClick={() => {
                      setMarqueOpen(false);
                      setMarque("");
                    }}
                  >
                    Annuler
                  </SecondaryButton>
                </div>
              </div>
            )}
          </div>
        </Modal1>
        <Modal1 isOpen={bigPhoto} onClose={() => setBigPhoto(null)}>
          <div
            className=" flex flex-col relative bg-white rounded-xl items-center justify-center h-screen w-screen cursor-pointer"
            style={{
              maxHeight: "70vh",
              maxWidth: "70vw",
            }}
            onClick={() => setBigPhoto(null)}
          >
            <img
              src={bigPhoto as any as string}
              alt="photo"
              className="rounded-xl w-full h-full object-contain "
            />
            <div className="absolute top-2 right-2 bg-blue-200 rounded-xl p-4">
              <SecondaryButton onClick={handleChangeLogo}>
                Changer le logo de l'entreprise
              </SecondaryButton>
            </div>
          </div>
        </Modal1>{" "}
        <div className="flex flex-col gap-2 h-fit  w-full pl-4 pb-80 ">
          <div className="text-h1 font-bold text-left  h-fit justify-between flex flex-row w-full">
            Entreprise{" "}
          </div>
          <TabGPT
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></TabGPT>
          {/* Première colonne */}
          {activeTab === "infos" && (
            <div className="flex flex-col gap-2 max-w-c500 pl-4 mt-2">
              <SaveBar
                condition={infos !== orgData.infos}
                onClick={callModifyMaster}
              />

              <div className="mb-4">
                <div className="text-h1 text-left font-medium mt-2 mb-4">
                  Logo entreprise
                </div>

                <div
                  className="rounded-xl border-1 border-shadow_10 h-10 mb-2 w-c100 flex flex-row items-center cursor-pointer"
                  onClick={() => setBigPhoto(orgData.logo)}
                >
                  {orgData.logo && (
                    <img
                      src={orgData.logo}
                      className="h-10 w-auto object-contain rounded-xl"
                    />
                  )}
                </div>
                <SecondaryButton
                  className={"w-fit h-fit"}
                  onClick={() => handleChangeLogo()}
                >
                  Ajouter un logo
                </SecondaryButton>

                <div className="text-h1 font-medium  text-left mb-6 mt-10">
                  Informations de l'entreprise
                </div>
                <div className="flex flex-col gap-1 w-full">
                  <TextField2T
                    className="w-full text-left"
                    label="ID"
                    value={orgData.id}
                    disabled={true}
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Entreprise"
                    value={infos?.entreprise}
                    onChange={(e) =>
                      setInfos({ ...infos, entreprise: e.target.value })
                    }
                  />

                  <TextField2T
                    className="w-full text-left"
                    label="Adresse"
                    value={infos?.adresse}
                    onChange={(e) =>
                      setInfos({ ...infos, adresse: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Postal"
                    value={infos?.postal}
                    onChange={(e) =>
                      setInfos({ ...infos, postal: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Ville"
                    value={infos?.ville}
                    onChange={(e) =>
                      setInfos({ ...infos, ville: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Adresse email de contact"
                    value={infos?.email}
                    onChange={(e) =>
                      setInfos({ ...infos, email: e.target.value })
                    }
                    mandatory={true}
                    type="email"
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Téléphone de contact"
                    value={infos?.phone}
                    onChange={(e) =>
                      setInfos({ ...infos, phone: e.target.value })
                    }
                    mandatory={true}
                    type="phone"
                  />
                </div>
              </div>
            </div>
          )}
          {/* Deuxième ligne pour les employés */}{" "}
          <div className="flex flex-col gap-2 max-w-c1p2k w-full px-4  mt-4">
            {activeTab === "members" && (
              <div className="w-full">
                <div className="text-h1 font-medium text-left flex flex-row gap-4 w-full">
                  Membres{" "}
                  {userData.org_admin && (
                    <SecondaryButton onClick={() => setAddMember(true)}>
                      Ajouter un nouveau membre
                    </SecondaryButton>
                  )}
                </div>
                <Space y={20} />
                <div className="flex flex-col max-w-c1p2k w-full border-1 border-shadow_10 rounded-lg ">
                  {users
                    .sort((a, b) => {
                      if (a.org_admin === b.org_admin) {
                        if (a.role === b.role) {
                          return (
                            b.tracking?.last_connection?.seconds ||
                            0 - a.tracking?.last_connection?.seconds ||
                            0
                          );
                        }
                        return a.role?.localeCompare(b.role);
                      }

                      return b.org_admin ? 1 : -1; // Place les admins en premier
                    })
                    .map((user, index) => (
                      <div key={index}>
                        <NiceMemberBlock
                          last={index === users.length - 1}
                          user={user}
                          userData={userData}
                          orgData={orgData}
                          handleMemberClick={handleMemberClick}
                        ></NiceMemberBlock>
                      </div>
                    ))}
                </div>
              </div>
            )}{" "}
            {activeTab === "notifications" && notifications && (
              <div className="flex flex-col  max-w-c500">
                <div className="text-h1 font-medium text-left mb-2">
                  Notifications
                </div>
                {!userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-bold">
                      Seul un administrateur peut accéder à cette partie.
                    </div>
                  </>
                )}
                {userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-normal items-center flex flex-row gap-2">
                      Seulement vous et les autres administrateurs pouvez
                      accéder à cette partie. Vous pouvez configurer les
                      notifications emails qui seront envoyées aux emails
                      définis.
                    </div>

                    <SaveBar
                      condition={notifications !== orgData.notifications}
                      onClick={handleSaveNotifications}
                    />

                    <div className="flex p-2 border-1 rounded-lg flex-col gap-2 my-4">
                      <div className="text-h3  ">
                        Emails définis pour recevoir les notifications de
                        hexagone
                      </div>
                      {notifications?.emails?.map((email, index) => (
                        <div
                          key={index}
                          className="flex flex-row gap-2 items-center border-l-"
                        >
                          <div className="text-h3   bg-blue-50 rounded-md px-1 py-0.5 text-blue-500">
                            {email}
                          </div>
                          <SecondaryButton
                            onClick={() => {
                              setNotifications({
                                ...notifications,
                                emails: notifications.emails.filter(
                                  (e) => e !== email
                                ),
                              });
                            }}
                          >
                            <Icon1 icon_name="delete" size={15}></Icon1>
                          </SecondaryButton>
                        </div>
                      ))}

                      <div className="flex flex-row gap-2 items-center border-l-">
                        <TextField2T
                          value={new_email}
                          onChange={(e) => setNewEmail(e.target.value)}
                          label={"Ajouter un email"}
                          type="email"
                          className="w-c200"
                        ></TextField2T>

                        <SecondaryButton
                          onClick={() => {
                            setNotifications({
                              ...notifications,
                              emails: notifications?.emails
                                ? [...notifications?.emails, new_email]
                                : [new_email],
                            });
                            setNewEmail("");
                          }}
                          disabled={!new_email || !new_email.includes("@")}
                          className="w-fit h-fit"
                        >
                          Ajouter cet email
                        </SecondaryButton>
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <ToggleSettingsBrick
                        title="Recevoir un email à chaque nouveau carnet"
                        description={
                          "  Recevoir un email à chaque nouvelle invitation sur un carnet"
                        }
                        checked={notifications?.email_new_demand_client}
                        onChange={(checked: any) => {
                          setNotifications({
                            ...notifications,
                            email_new_demand_client: checked,
                          });
                        }}
                      ></ToggleSettingsBrick>

                      <ToggleSettingsBrick
                        title="Recevoir un email à chaque nouveau message"
                        description={
                          "   Recevoir un email à chaque nouveau message envoyé depuis hexagone par un partenaire."
                        }
                        checked={notifications?.email_new_chat_message}
                        onChange={(checked: any) => {
                          setNotifications({
                            ...notifications,
                            email_new_chat_message: checked,
                          });
                        }}
                      ></ToggleSettingsBrick>
                      <ToggleSettingsBrick
                        title="Recevoir un email à chaque recharge"
                        description={
                          "   Recevoir un email à chaque paiement effectué sur votre compte."
                        }
                        checked={notifications?.email_new_successful_payment}
                        onChange={(checked: any) => {
                          setNotifications({
                            ...notifications,
                            email_new_successful_payment: checked,
                          });
                        }}
                      ></ToggleSettingsBrick>

                      {/* <ToggleSettingsBrick
                        title="Recevoir un emaill lorsqu'un partenaire est supprimé"
                        description={
                          "   Recevoir un email lorsqu'un partenaire est supprimé parmi vos partenaires."
                        }
                        checked={notifications?.email_partner_deleted}
                        onChange={(checked: any) => {
                          setNotifications({
                            ...notifications,
                            email_partner_deleted: checked,
                          });
                        }}
                      ></ToggleSettingsBrick> */}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>{" "}
        </div>
      </div>{" "}
    </div>
  );
};
export default Organisation;

interface NiceMemberBlockProps {
  last?: boolean;
  user: User;
  handleMemberClick: (user_id: string, isinfos: any) => void;
  orgData?: Org;
  userData?: User;
  setMemberOpen?: (user_id: string) => void;
  canopen?: boolean;
  show_id?: boolean;
}

export const NiceMemberBlock = ({
  last = false,
  user,
  handleMemberClick,
  orgData,
  userData,

  setMemberOpen,
  canopen,
  show_id,
}: NiceMemberBlockProps) => {
  return (
    <div className={`flex flex-col p-2 w-full ${last ? " border-b-1" : ""}`}>
      <div className="flex w-full flex-col ">
        <div className="flex flex-row gap-2 w-full items-center">
          <div className="relative">
            <img
              src={
                user.photo ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR2dtSs0-ybB7OnCnfsC1UWgViGQLxAtVx83IPHmxIjh1istqxGhm2sjWOSF1TDN_J-r0&usqp=CAU"
              }
              alt="photo"
              className="min-h-10 min-w-10 h-10 w-10 rounded-full"
            />
            <div
              className="absolute -bottom-1 -right-0 bg-white p-0.5
        rounded-full flex items-center justify-center"
            >
              <Icon1
                icon_name={user.org_admin ? "settings-filled" : ""}
                size={11}
                fill={user.org_admin ? "black" : "grey"}
              />
            </div>
          </div>
          <div className="w-full flex items-center">
            {/* Limiter la largeur du nom pour aligner les emails */}
            <div className="flex w-full max-w-c300 flex-col px-1">
              <div className="flex-1 font-medium text-h2   truncate">
                {user.display_name}
              </div>
              {/* Centrer l'email dans son div */}
              <div className="flex-1  text-h3 font-normal text-left">
                {user.email}
              </div>
              {show_id && (
                <div className="flex-1  text-h3 font-normal text-left">
                  {user.id}
                </div>
              )}
            </div>
            <div className=" w-c250 ">
              <div
                className={`rounded-xl   w-fit  px-2 py-0.5 text-h3 text-shadow_50`}
              >
                {getRoleString(user?.role)}
              </div>
            </div>
            {/* Centrer l'email dans son div */}
            <Tippy
              content="Dernière connexion"
              className="custom-tooltip"
              placement="top"
              delay={500}
            >
              <div className="w-c150 text-h3 font-normal text-left">
                {user.tracking?.last_connection ? (
                  new Date(
                    user.tracking?.last_connection?.seconds * 1000
                  ).toLocaleString()
                ) : (
                  <span className="text-neutral-300">Jamais connecté</span>
                )}
              </div>
            </Tippy>
            {userData && (
              <Tippy
                content="Modifier la couleur"
                className="custom-tooltip"
                placement="top"
                delay={500}
              >
                <div className="ml-auto">
                  <div
                    onClick={() => handleMemberClick(user.id, false)}
                    className={` rounded-full w-4 h-4 border-1 border-shadow_50 cursor-pointer`}
                    style={{
                      backgroundColor: user.color
                        ? flutterColorToHex(user.color)
                        : "transparent",
                    }}
                  />
                </div>
              </Tippy>
            )}

            {(canopen || userData?.org_admin) && (
              <div className="ml-2">
                <Tippy
                  content="Modifier les informations"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <SecondaryButton
                      onClick={() =>
                        (setMemberOpen && setMemberOpen(user.id)) ||
                        (handleMemberClick && handleMemberClick(user.id, true))
                      }
                    >
                      Modifier
                    </SecondaryButton>
                  </div>
                </Tippy>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
